import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Typography from '@mui/material/Typography';

import { Box, Button, Stack } from '@src/components';


export default function YearSwitcher({ currentDates, onPrev, onNext}) {
  const year = currentDates.start.getFullYear();

  return (
    <Box sx={StyleSheet.container}>
      <Stack spacing={1} alignItems="center" direction="row">
        <Button
          sx={StyleSheet.control}
          onClick={onPrev}
          startIcon={<ArrowBackIosNewIcon fontSize="small" />}
        />

        <Typography variant="h3" sx={StyleSheet.year}>{year}</Typography>

        <Button
          sx={StyleSheet.control}
          onClick={onNext}
          endIcon={<ArrowForwardIosIcon fontSize="small" />}
        />
      </Stack>
    </Box>

  );
}

const StyleSheet = {
  container: (theme) => ({
    background: theme.palette.grey[600],
    width: 'fit-content',
  }),
  control: (theme) => ({
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      fill: theme.palette.common.white,
    },
    padding: 0,
    minWidth: '60px',
  }),
  year: (theme) => ({
    color: theme.palette.common.white,
  }),
};
